/* FIX: wishlist heart toggle + unified toast (add/remove); localStorage — no third-party app toast */
const STORAGE_KEY = 'gokay_wishlist';

/**
 * @returns {string[]}
 */
function getWishlist() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
  } catch {
    return [];
  }
}

/**
 * @param {string[]} list
 */
/**
 * @param {string[]} list
 * @param {{ handle?: string; adding?: boolean }} [meta]
 */
function saveWishlist(list, meta = {}) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
  } catch {
    /* ignore quota errors */
  }

  document.dispatchEvent(
    new CustomEvent('wishlist:change', {
      bubbles: true,
      detail: {
        handles: [...list],
        handle: meta.handle ?? null,
        adding: meta.adding ?? null,
      },
    })
  );
}

function updateHeaderBadge() {
  const badge = document.getElementById('wishlist-header-badge');
  if (!badge) return;

  const count = getWishlist().length;
  const newText = count > 0 ? count.toString() : '';
  if (badge.textContent !== newText) badge.textContent = newText;

  const visible = count > 0;
  if (badge.classList.contains('wishlist-header-badge--visible') !== visible) {
    badge.classList.toggle('wishlist-header-badge--visible', visible);
  }
}

function syncAllButtons() {
  const wishlist = getWishlist();

  document.querySelectorAll('.wishlist-heart-icon[data-product-handle]').forEach((btn) => {
    const handle = btn.getAttribute('data-product-handle');
    if (!handle) return;

    const isFav = wishlist.includes(handle);
    if (btn.classList.contains('is-active') !== isFav) {
      btn.classList.toggle('is-active', isFav);
      btn.setAttribute('aria-label', isFav ? 'Favorilerden çıkar' : 'Favorilere ekle');
    }
  });

  updateHeaderBadge();
}

/**
 * @param {HTMLElement} button
 */
function triggerWishlistPop(button) {
  if (!button || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const icon = button.querySelector('.wishlist-heart-icon__svg');
  if (!icon) return;

  button.classList.remove('wishlist-heart-icon--pop');
  void button.offsetWidth;
  button.classList.add('wishlist-heart-icon--pop');

  icon.addEventListener(
    'animationend',
    () => {
      button.classList.remove('wishlist-heart-icon--pop');
    },
    { once: true }
  );
}

/**
 * @param {boolean} adding
 */
function showWishlistToast(adding) {
  const stack = document.getElementById('site-toast-stack');
  const wishlistUrl = stack?.dataset.wishlistUrl || '/pages/favoriler';

  if (!window.SiteToast) return;

  if (adding) {
    window.SiteToast.show({
      id: 'wishlist',
      variant: 'compact',
      title: 'Favorilere Eklendi',
      icon: 'heart-filled',
      actionLabel: 'Favorilerime git →',
      actionHref: wishlistUrl,
    });
  } else {
    window.SiteToast.show({
      id: 'wishlist',
      variant: 'compact',
      title: 'Favorilerden Çıkarıldı',
      icon: 'heart-outline',
    });
  }
}

/**
 * @param {MouseEvent} event
 */
function handleHeartClick(event) {
  const btn = event.target instanceof Element ? event.target.closest('.wishlist-heart-icon[data-product-handle]') : null;
  if (!btn) return;

  event.preventDefault();
  event.stopPropagation();

  const handle = btn.getAttribute('data-product-handle');
  if (!handle) return;

  const wishlist = getWishlist();
  const index = wishlist.indexOf(handle);
  const adding = index === -1;

  if (adding) {
    wishlist.push(handle);
  } else {
    wishlist.splice(index, 1);
  }

  saveWishlist(wishlist, { handle, adding });

  if (window.wishlistObserver) window.wishlistObserver.disconnect();
  syncAllButtons();
  if (window.wishlistObserver) {
    window.wishlistObserver.observe(document.body, { childList: true, subtree: true });
  }

  showWishlistToast(adding);
  if (adding) triggerWishlistPop(btn);
}

function initWishlistHeart() {
  if (document.body.dataset.wishlistHeartInit === 'true') return;
  document.body.dataset.wishlistHeartInit = 'true';

  document.addEventListener('click', handleHeartClick);

  syncAllButtons();

  window.wishlistObserver = new MutationObserver((mutations) => {
    const shouldSync = mutations.some((mutation) => mutation.addedNodes.length > 0);
    if (!shouldSync || !window.wishlistObserver) return;

    window.wishlistObserver.disconnect();
    syncAllButtons();
    window.wishlistObserver.observe(document.body, { childList: true, subtree: true });
  });

  window.wishlistObserver.observe(document.body, { childList: true, subtree: true });
}

window.Wishlist = {
  STORAGE_KEY,
  getWishlist,
  saveWishlist,
  syncAllButtons,
  updateHeaderBadge,
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initWishlistHeart);
} else {
  initWishlistHeart();
}
